import { Box } from "@mui/material";
import React from "react";

import { UnclearButton } from "new-components/buttons/UnclearButton";

import { DeleteImageQueryButton } from "./DeleteImageQueryButton";
import { InappropriateFlagButton } from "./InappropriateFlagButton";

export interface UnclearActionsRowProps {
  hasImageQuery: boolean;
  isUnclearMenuOpen: boolean;
  setUnclearMenuOpen: (state: boolean) => void;
  onUnclearSubmit: (feedbackText: string) => void;
  hideHotkey?: boolean;
  showDeleteButton?: boolean;
  onDeleteImageQuery?: () => void | Promise<void>;
  isDeletingImageQuery?: boolean;
}

export function UnclearActionsRow(props: UnclearActionsRowProps) {
  const {
    hasImageQuery,
    isUnclearMenuOpen,
    setUnclearMenuOpen,
    onUnclearSubmit,
    hideHotkey,
    showDeleteButton = false,
    onDeleteImageQuery,
    isDeletingImageQuery = false,
  } = props;

  return (
    <Box display="flex" gap="5px">
      <UnclearButton
        showButton={hasImageQuery}
        setUnclearMenuOpen={setUnclearMenuOpen}
        isUnclearMenuOpen={isUnclearMenuOpen}
        onSubmit={onUnclearSubmit}
        hideHotkey={hideHotkey}
      />
      {showDeleteButton && onDeleteImageQuery && (
        <DeleteImageQueryButton
          onDelete={onDeleteImageQuery}
          isDeleting={isDeletingImageQuery}
          isUnclearMenuOpen={isUnclearMenuOpen}
        />
      )}
      <InappropriateFlagButton onUnclearSubmit={onUnclearSubmit} />
    </Box>
  );
}
